<template>
  <div class="container">
    <div class="row col-3">
      <h5 class="text-azul">ICONOGRAFÍA</h5>
    </div>
    <div class="container iconos d-none d-md-flex mb-4 pt-3 col-12 mx-auto justify-content-between">
      <div class="row col-3">
        <table class="table table-borderless table-sm">
          <tbody>
            <tr>
              <th scope="col" class="pr-3">
                <img
                  src="@/assets/img/iconos/acreditacion-8.svg"
                  alt="Años de acreditación"
                  class="small-ic"
                />
              </th>
              <td class="text-nowrap">Años de Acreditación Institucional</td>
            </tr>
            <tr>
              <th scope="col" class="pr-3">
                <img
                  src="@/assets/img/iconos/lista-espera.svg"
                  alt="Lista de espera"
                  class="small-ic"
                />
              </th>
              <td>Lista de Espera</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row col-3 pl-0">
        <table class="table table-borderless table-sm">
          <tbody>
            <tr>
              <th scope="col" class="pr-3">
                <img
                  src="@/assets/img/iconos/jornada-dia.svg"
                  alt="Jornada diurna"
                  class="small-ic"
                />
              </th>
              <td>Presencial Diurna</td>
            </tr>
            <tr>
              <th scope="col" class="pr-3">
                <img
                  src="@/assets/img/iconos/jornada-noche.svg"
                  alt="Jornada vespertina"
                  class="small-ic"
                />
              </th>
              <td>Presencial Vespertina</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row col-3 pl-0">
        <table class="table table-borderless table-sm">
          <tbody>
            <tr>
              <th scope="col" class="pr-3">
                <img
                  src="@/assets/img/iconos/postulacion-abierta.svg"
                  alt="Postulaciones abiertas"
                  class="small-ic"
                />
              </th>
              <td>Postulación Abierta</td>
            </tr>
            <tr>
              <th scope="col" class="pr-3">
                <img
                  src="@/assets/img/iconos/postulacion-cerrada.svg"
                  alt="Postulaciones cerradas"
                  class="small-ic"
                />
              </th>
              <td>Postulación Cerrada</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row col-3 pl-0">
        <table class="table table-borderless table-sm">
          <tbody>
            <!--<tr>
              <th scope="col" class="pr-3">
                <img
                  src="@/assets/img/iconos/gratuidad-4.svg"
                  alt="Adscrita a gratuidad"
                  class="small-ic"
                />
              </th>
              <td>Adscrita a Gratuidad</td>
            </tr>-->
            <tr>
              <th scope="col" class="pr-3">
                <img
                  src="@/assets/img/iconos/modo-a-distancia-2.svg"
                  alt="Modalidad a distancia"
                  class="small-ic"
                />
              </th>
              <td>Modalidad a Distancia</td>
            </tr>
            <tr>
              <th scope="col" class="pr-3">
                <img
                  src="@/assets/img/iconos/modo-semi-presencial-2.svg"
                  alt="Modalidad semi-presencial"
                  class="small-ic"
                />
              </th>
              <td>Modalidad Semipresencial</td>
            </tr>
            <!-- <tr>
              <th scope="col" class="pr-3"><img src="assets/img/iconos/comparador.svg" class="small-ic" /></th>
              <td scope="col">Comparador de carreras</td>
            </tr>-->
          </tbody>
        </table>
      </div>
    </div>
    <div class="container iconos d-flex d-md-none mb-4 pt-3 col-12 mx-auto justify-content-between">
      <div class="row col-6">
        <table class="table table-borderless table-sm">
          <tbody>
            <tr>
              <th scope="col" class="pr-3">
                <img
                  src="@/assets/img/iconos/jornada-dia.svg"
                  alt="Jornada diurna"
                  class="small-ic"
                />
              </th>
              <td>Presencial Diurna</td>
            </tr>
            <tr>
              <th scope="col" class="pr-3">
                <img
                  src="@/assets/img/iconos/jornada-noche.svg"
                  alt="Jornada vespertina"
                  class="small-ic"
                />
              </th>
              <td>Presencial Vespertina</td>
            </tr>
            <!--<tr>
              <th scope="col" class="pr-3">
                <img
                  src="@/assets/img/iconos/gratuidad-4.svg"
                  alt="Adscrita a gratuidad"
                  class="small-ic"
                />
              </th>
              <td>Adscrita a Gratuidad</td>
            </tr>-->
            <tr>
              <th scope="col" class="pr-3">
                <img
                  src="@/assets/img/iconos/postulacion-abierta.svg"
                  alt="Postulaciones abiertas"
                  class="small-ic"
                />
              </th>
              <td>Postulación Abierta</td>
            </tr>
            <tr>
              <th scope="col" class="pr-3">
                <img
                  src="@/assets/img/iconos/acreditacion-8.svg"
                  alt="Años de acreditación"
                  class="small-ic"
                />
              </th>
              <td>Años de Acreditación Institucional</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row col-6 pl-0">
        <table class="table table-borderless table-sm">
          <tbody>
            <tr>
              <th scope="col" class="pr-3">
                <img
                  src="@/assets/img/iconos/lista-espera.svg"
                  alt="Lista de espera"
                  class="small-ic"
                />
              </th>
              <td>Lista de Espera</td>
            </tr>
            <tr>
              <th scope="col" class="pr-3">
                <img
                  src="@/assets/img/iconos/modo-semi-presencial-2.svg"
                  alt="Modalidad semi-presencial"
                  class="small-ic"
                />
              </th>
              <td>Modalidad Semipresencial</td>
            </tr>
            <tr>
              <th scope="col" class="pr-3">
                <img
                  src="@/assets/img/iconos/modo-a-distancia-2.svg"
                  alt="Modalidad a distancia"
                  class="small-ic"
                />
              </th>
              <td>Modalidad a Distancia</td>
            </tr>
            <tr>
              <th scope="col" class="pr-3">
                <img
                  src="@/assets/img/iconos/postulacion-cerrada.svg"
                  alt="Postulaciones cerradas"
                  class="small-ic"
                />
              </th>
              <td>Postulación Cerrada</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Iconografia"
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/generales/Iconografia.vue